module.exports = __webpack_public_path__ + "img/ic-white-onde-dormir.f1cddac9.svg";